import {populateLinkBox} from "../linkBox/populateLinkBox.js";
import {populateVideoBox} from "../videoBox/populateVideoBox.js";
import {populateSocialMediaBox} from "../socialMediaBox/populateSocialMediaBox.js";
import {populateImagesBox} from "../imagesBox/populateImagesBox.js";
import {populateItemBox} from "../itemBox/populateItemBox.js";
import {populateCollectPointsBox} from "../../points/populateCollectPointsBox.js";
import {populateCodeActionBox} from "../../points/populateCodeActionBox.js";
import {populateRansomActionBox} from "../ransomAction/populateRansomActionBox.js";
import {renameTimelineTypeHtml} from "../../utils/renameTimelineTypeHtml.js";
import {getAuthor} from "../../author/getAuthor.js";
export function positionStammtischContents(jsonObj, lazyLoadOnThisPage) {
    let data = $.parseJSON(jsonObj);
    $.each(data.timeline_elements, function (key, value) {
        let stammtischElement = data.stammtisch_elements[value.post_id];

        let container = $("#" + value.id + ".timeline_entry");
        if (stammtischElement.active) {
            container.find(".spinner").hide();
            let smileySelector = ".timeline_entry#" + value.id + " .smiley_input";
            switch (stammtischElement.type) {
                case 1:
                    populateLinkBox(stammtischElement, container, value);
                    enableSmilies(smileySelector);
                    break;
                case 2:
                    populateVideoBox(stammtischElement, container, value);
                    enableSmilies(smileySelector);
                    break;
                case 3:
                    populateSocialMediaBox(stammtischElement, container, value);
                    enableSmilies(smileySelector);
                    break;
                case 4:
                    populateImagesBox(stammtischElement, container, value);
                    enableSmilies(smileySelector);
                    break;
                case 5:
                    populateItemBox(stammtischElement, container, value);
                    break;
                case 6:
                    populateCollectPointsBox(stammtischElement, container, value);
                    break;
                case 7:
                    populateCodeActionBox(stammtischElement, container, value);
                    break;
                case 8:
                    populateRansomActionBox(stammtischElement, container, value);
                    break;
                default:
                    container.addClass(stammtischElement.type);
            }
            if (stammtischElement.author !== "") {
                getAuthor(stammtischElement, value);
            } else {
                container.find(".js-post-author-image img").attr("src", "/layout/frontend/stiegl/dist/images/no-profile-pic.png");
            }
            if (stammtischElement.from_shop_user_id !== null) {
               renameTimelineTypeHtml(stammtischElement.from_shop_user_id, container);
            }
        } else {
            container.remove();
        }
    });
    lazyLoad = lazyLoadOnThisPage;
}